import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ExpandContentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ExpandContentSVG;
